import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Resolve, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { JpatsPolicyPermissionsService } from './jpats-policy-permissions.service';
import { ToastService } from './../../../../../shared/core/services/toast.service';

@Injectable()
export class JpatsPolicyPermissionsGuard implements CanActivate, Resolve<any> {

  constructor(private injector: Injector, private policyPermissionsService: JpatsPolicyPermissionsService, private toastService: ToastService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return await this.execCanActivate(route, state);
  }

  async execCanActivate(route, state): Promise<boolean> {
    if (!route.data.permissions && !route.data.permission_application) {
      return true;
    }
    let permissions = [];
    let requireOr = [];
    let requireAnd = [];
    if (route.data.permissions) {
      let permObj: any = route.data.permissions;
      if (permObj instanceof Object && (permObj.any || permObj.all)) {
        if (Array.isArray(permObj.or)) {
          requireOr = permObj.or;
        }
        if (Array.isArray(permObj.and)) {
          requireAnd = permObj.and;
        }
      } else if (Array.isArray(permObj)) {
        requireOr = permObj;
      }
      permissions = requireOr.concat(requireAnd);
    }

    // if (route.data.permission_application) {
    //   let permission_list = await this.policyPermissionsService.loadPermissionsByApplication(route.data.permission_application);
    //   permissions = permissions.concat(permission_list.map(permission => permission.permissionName));
    // }

    let effectivePermissions = await this.policyPermissionsService.loadEffectivePermissions(permissions);
    let ok = true;
    if (permissions.length > 0) {
      let missingPermissions = effectivePermissions.permissions.filter((effectivePermission) =>
        !!!permissions.find((permission) => effectivePermission.permissionName === permission));

      if (!this.policyPermissionsService.hasSystemRoot(effectivePermissions) && (requireAnd.length > 0 || requireOr.length > 0)) {

        if (ok && requireAnd.length > 0 && !!requireAnd.find((permission) =>
          !!missingPermissions.find((missingPermission) => missingPermission.permissionName === permission))) {
          ok = false;
        }

        if (ok && requireOr.length > 0 && !!!requireOr.find((permission) =>
          !!effectivePermissions.permissions.find((effectivePermission) => effectivePermission.permissionName === permission))) {
          ok = false;
        }

      }
    }

    if (!ok) {
      this.toastService.showError("Access denied");
      return false;
    }
    return true;
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    let applications: string[] = route.data.applications;
    let permissions: string[] = route.data.resolvePermissions;
    let promises: Promise<any>[] = [];

    // if (applications && applications.length > 0) {
    //   applications.forEach((application) => promises.push(this.policyPermissionsService.loadPermissionsByApplication(application)));
    // }
    if (permissions && permissions.length > 0) {
      promises.push(this.policyPermissionsService.loadEffectivePermissions(permissions));
    }

    return Promise.all(promises);
  }
}
